import React, { FunctionComponent } from "react"
import { Redirect, Route } from "react-router"
import { useSelector } from "../../store"
import { iRoute } from "../../Routes"
import NoPermission from "../../pages/NoPermission/NoPermission"

const PrivateRoute: FunctionComponent<iRoute> = ({
  component: Component,
  childrenRoutes,
  permission,
  ...rest
}) => {
  const {
    user: { isLoggedIn, permissions },
  } = useSelector(({ user }) => ({
    user,
  }))

  return (
    <Route {...rest}>
      {isLoggedIn ? (
        permissions?.find(({ name }) => name === permission) ? (
          <>
            <Component />
            {childrenRoutes?.map((childRoute, i) => (
              <PrivateRoute key={i} {...childRoute} />
            ))}
            {}
          </>
        ) : (
          <>
            {/* TODO FIX */}
            <Redirect to={"/no-permission"} />
            <Route component={NoPermission} />
          </>
        )
      ) : (
        <Redirect to={"/login"} />
      )}
    </Route>
  )
}

export default PrivateRoute
